// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2CVk9","header":"ReportDetails_header__3nIRT","title":"ReportDetails_title__hYOtw","left":"ReportDetails_left__3mT-d"};